import React from "react";
import { UseFormWatch } from "react-hook-form";
import PassportAndVisaImage from "app/components/imagesUploads/joint/PassportAndVisaImage";
import Checkbox from "app/components/common/inputs/Checkbox";

type AllowedFieldNames = "passport" | "visa" | "copassport" | "covisa";
interface ImageFieldConfig {
  label: string;
  subTitle: string;
  fieldName: AllowedFieldNames;
  previewUrl: string | null;
  savedFileUrl?: string;
  error?: any;
  fileInputRef: React.RefObject<HTMLInputElement>;
}

interface PassportAndVisaSectionProps {
  imageFields: ImageFieldConfig[];
  register: any;
  watch: UseFormWatch<any>;
  onFileChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: AllowedFieldNames
  ) => void;
  onChooseFile: (fieldName: AllowedFieldNames) => void;
  onDeleteImage: (fieldName: AllowedFieldNames) => void;
}

const PassportAndVisa: React.FC<PassportAndVisaSectionProps> = ({
  imageFields,
  register,
  onFileChange,
  onChooseFile,
  onDeleteImage,
  watch,
}) => {
  return (
    <div className="text-left">
      <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-2">
        Upload passport & visa image
        <span className="text-danger">*</span>
      </h6>
      <div className="mt-6 mb-2">
        <Checkbox
          id={`terms`}
          labelHtml={
            <span className="text-[#98A2B3] text-[12px]">
              I have a valid Passport
            </span>
          }
          checked={true}
          disabled={true}
          onChange={(e) => {}}
          labelClassName="sm:mt-[-15px]"
        />
      </div>

      <div className="flex gap-7 sm:gap-4  flex-col lg:flex-row justify-between">
        {imageFields.map((field) => (
          <PassportAndVisaImage
            key={field.fieldName}
            subTitle={field.subTitle}
            label={field.label}
            previewUrl={field.previewUrl}
            fieldName={field.fieldName}
            savedFileUrl={field.savedFileUrl}
            register={register}
            error={field.error}
            fileInputRef={field.fileInputRef}
            watch={watch}
            onFileChange={(e) => onFileChange(e, field.fieldName)}
            onChooseFile={() => onChooseFile(field.fieldName)}
            onDelete={() => onDeleteImage(field.fieldName)}
          />
        ))}
      </div>
    </div>
  );
};

export default PassportAndVisa;
